module.exports = __webpack_public_path__ + "media/images/head-icon-b96c00af4b1e29871ac757ca0285b4a4.svg";